<router-outlet></router-outlet>
<ng-template ngbModalContainer></ng-template>
<app-loader></app-loader>
